import React from 'react'

const MiddleSection = () => {
  return (
   <>
     <div className="middle_container">
                <div className="subset_middle">
                    <div className="navigation_detail_div">
                        <p>UI/UX > Refer & Earn > Friends > Referred</p>
                    </div>
                    <div className="referal_wallet_parent">

                        <div className="referral_code_div">
                            <p>Your Referral Code</p>
                            <div className="referal_code_value">

                                <span>E</span>
                                <span>D</span>
                                <span>C</span>
                                <span>H</span>
                                <span>5</span>
                                <span>4</span>

                            </div>

                        </div>

                        <div className="wallet_div">
                            <div className="wallet_inner">
                                <p>Wallet Balance</p>
                                <h3>₹ 500</h3>
                            </div>
                        </div>
                    </div>

                    <div className="enroll_card_parent">

                        <div className="friend_enroll_div">
                            <h4>Friends who enrolled<span>(3)</span></h4>
                        </div>

                        <div className="cards_parent">
                            <div className="card1">
                                <div className="Name_date_parent">
                                    <div className="Name_div">
                                        <h3>Dhiraj Saxsena</h3>
                                    </div>
                                    <div className="date_div">
                                        <p>14 Sep,2022</p>
                                    </div>
                                </div>

                                <div className="courses_enrl_div">
                                    <p>Courses Enrolled(6)</p>
                                </div>

                                <div className="course_detail_parent">
                                    <p>UI/UX</p>
                                    <p>Photoshop</p>
                                    <p>Illustrator</p>

                                </div>

                                <div className="course_detail_parent">
                                    <p>Python</p>
                                    <p>MERN</p>
                                    <p>Java</p>

                                </div>

                                <div className="referal_amount_div">
                                    <p>Referral Amount</p>
                                    <h1>₹185</h1>

                                </div>

                            </div>

                            <div className="card1">
                                <div className="Name_date_parent">
                                    <div className="Name_div">
                                        <h3>Subhash Mishra</h3>
                                    </div>
                                    <div className="date_div">
                                        <p>15 Sep,2022</p>
                                    </div>
                                </div>

                                <div className="courses_enrl_div">
                                    <p>Courses Enrolled(23)</p>
                                </div>

                                <div className="course_detail_parent">
                                    <p>UI/UX</p>
                                    <p>Photoshop</p>
                                    <p>Illustrator</p>

                                </div>

                                <div className="course_detail_parent">
                                    <p>Python</p>
                                    <p>MERN</p>
                                    <p>Java</p>
                                    <p>C++</p>

                                </div>

                                <div className="referal_amount_div">
                                    <p>Referral Amount</p>
                                    <h1>₹485</h1>

                                </div>

                            </div>

                            <div className="card1">
                                <div className="Name_date_parent">
                                    <div className="Name_div">
                                        <h3>Prafull Kumar</h3>
                                    </div>
                                    <div className="date_div">
                                        <p>15 Sep,2022</p>
                                    </div>
                                </div>

                                <div className="courses_enrl_div">
                                    <p>Courses Enrolled(23)</p>
                                </div>

                                <div className="course_detail_parent">
                                    <p>UI/UX</p>
                                    <p>Photoshop</p>
                                    <p>Illustrator</p>

                                </div>

                                <div className="course_detail_parent">
                                    <p>Python</p>
                                    <p>MERN</p>
                                    <p>Java</p>
                                    <p>C++</p>

                                </div>

                                <div className="referal_amount_div">
                                    <p>Referral Amount</p>
                                    <h1>₹485</h1>

                                </div>

                            </div>



                        </div>

                        <div className="tc_div">
                            <p>Terms & Conditions</p>
                        </div>

                    </div>


                </div>


            </div>
   
   </>
  )
}

export default MiddleSection
